import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IDeleteUserRemoteAgentsParams {
  ownerId: string;
  deviceIds: string[];
}

export class DeleteUserRemoteAgentsRequest extends Request<IDeleteUserRemoteAgentsParams, IResult> {
  constructor(params: IDeleteUserRemoteAgentsParams) {
    super('deleteUserRemoteAgents', params);
  }
}
